import { smb_fetch, getAgpApiUrl } from '@/api/operator/fetch';

/**
 * 获取广告主的服务商uid
 * @param {number} uid: 广告主uid
 */
export const getAgencyUidByUid = (uid: string) => {
  const url = getAgpApiUrl('agency', 'get_agency_info_by_advertiser_info');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    {
      data: { uid },
    },
  );

  return smb_fetch<any>(url, params);
};
